const styles = {
  container: {
    justifyContent: 'space-between',
    padding: '10px 25px',
    backgroundColor: 'white',
  },
  headerData: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  dataValueMargin0: {
    fontWeight: 'bold',
  },
  dataValue: {
    fontWeight: 'bold',
    marginLeft: 5,
  },
  text: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 300,
  },

};

export default styles;
